(() => {
  'use strict';
  document.querySelectorAll('[data-showroom-booking]').forEach(panel => {
    const date = panel.querySelector('[data-booking-date]');
    const model = panel.querySelector('[data-booking-model]');
    const link = panel.querySelector('[data-booking-link]');
    const now = new Date();
    date.min = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
    // Only accept a short, plain selection passed from our product page.
    model.value = (new URLSearchParams(window.location.search).get('selection') || '').slice(0,120);
    const sync = () => {
      const url = new URL(`https://wa.me/${panel.dataset.whatsapp.replace(/\D/g,'')}`);
      const line = (label, value) => (value ? `${label || ''}${value}` : '');
      url.searchParams.set('text', [panel.dataset.intro, line(panel.dataset.labelShowroom, panel.dataset.showroom), line(panel.dataset.labelDate, date.validity.valid ? date.value : ''), line(panel.dataset.labelModel, model.value.trim()), panel.dataset.source].filter(Boolean).join('\n'));
      link.href = url.href;
    };
    panel.addEventListener('input',sync);
    link.addEventListener('click', event => {
      if (!date.validity.valid) { event.preventDefault(); date.reportValidity(); }
    });
    sync();
  });
})();
